import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, ShieldCheck } from 'lucide-react';
import { createPageUrl } from '@/utils';
import { Badge } from '@/components/ui/badge';
import AdminVideoUploadJobList from '@/components/admin/videoCreate/AdminVideoUploadJobList';
import { ADMIN_FEATURES } from '@/config/adminFeatures';
import { useRequireAdminRedirect } from '@/hooks/useRequireAdminRedirect';

export default function AdminIndex() {
  const { canRenderProtectedContent, isLoadingAuth } = useRequireAdminRedirect();

  if (isLoadingAuth || !canRenderProtectedContent) return null;

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#faf6f1] via-[#f5ede3] to-[#efe5d8] text-[#2d1810] pb-20">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="text-center mb-12">
          <div className="w-16 h-16 rounded-2xl bg-[#8b6f47]/20 flex items-center justify-center mx-auto mb-4">
            <ShieldCheck className="w-8 h-8 text-[#8b6f47]" />
          </div>
          <h1 className="text-3xl font-bold mb-2 text-[#2d1810]">admin専用ページ</h1>
          <p className="text-[#5d4529]">管理者向け機能の一覧です</p>
        </div>

        {/* 変換中・完了・失敗をここで拾えるようにする。該当が無いときは何も描画しない */}
        <AdminVideoUploadJobList
          enabled={canRenderProtectedContent}
          limit={3}
          className="mb-4"
        />

        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
          {ADMIN_FEATURES.map((feature) => (
            <Link
              key={feature.page}
              to={createPageUrl(feature.page)}
              className="group flex items-center gap-4 rounded-xl border border-[#e8dccd] bg-white p-5 transition-all hover:-translate-y-0.5 hover:border-[#d4c4b0] hover:shadow-md"
            >
              <div className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-xl bg-[#8b6f47]/15">
                <feature.icon className="h-6 w-6 text-[#8b6f47]" />
              </div>
              <div className="min-w-0 flex-1">
                <div className="flex flex-wrap items-center gap-2">
                  <h2 className="font-semibold text-[#2d1810] transition-colors group-hover:text-[#8b6f47]">
                    {feature.label}
                  </h2>
                  {!feature.isAvailable && (
                    <Badge variant="outline" className="border-[#d4c4b0] text-[10px] text-[#6b5540]">
                      準備中
                    </Badge>
                  )}
                </div>
                <p className="mt-1 text-sm text-[#6b5540]">{feature.description}</p>
              </div>
              <ChevronRight className="h-5 w-5 flex-shrink-0 text-[#8b6f47]" />
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
